/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ActionConstants from '../constants';
import {
  getTodayTransactionsDataApi,
  getOverviewDataApi,
  getOverviewSettlementDataApi,
  getEdgeTodayTransactionsDataApi,
  getEdgeOverviewSettlementDataApi,
  getEdgeOverviewDataApi,
  getBetaToggleApi,
  getCheckoutInsightsOfferEffectivenessAPI,
  getCheckoutInsightsPaymentModeBreakdownAPI,
  getCheckoutInsightsPaymentPerformanceAPI,
  getCheckoutInsightsConversionFunnelAPI,
} from '../../api/overview';
import { getCancelableRequestMeta } from './cancelableRequest';

export const getBetaToggleAction = (emailId: string) => {
  const payload = {
    serviceMethod: getBetaToggleApi.bind(null, emailId, ActionConstants.GET_BETA_TOGGLE),
    actionTypeRequest: ActionConstants.GET_BETA_TOGGLE_REQUEST,
    actionTypeSuccess: ActionConstants.GET_BETA_TOGGLE_SUCCESS,
    actionTypeFailure: ActionConstants.GET_BETA_TOGGLE_FAILURE,
    hideLoader: true,
    cancelKey: ActionConstants.GET_BETA_TOGGLE,
  };
  return { type: ActionConstants.GET_BETA_TOGGLE, payload };
};

export const clearBetaToggleStateAction = () => ({
  type: ActionConstants.CLEAR_BETA_TOGGLE_STATE,
});

export const getTodayTransactionsDataAction = (data) => {
  const payload = {
    serviceMethod: getTodayTransactionsDataApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_TODAY_TRANSACTIONS_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.GET_TODAY_TRANSACTIONS_DATA_FAILURE,
    actionTypeRequest: ActionConstants.GET_TODAY_TRANSACTIONS_DATA_REQUEST,
  };
  return { type: ActionConstants.GET_TODAY_TRANSACTIONS_DATA, payload };
};

export const getEdgeTodayTransactionsDataAction = (data = {}) => {
  const { cancelKey, requestId, requestData, hideLoader } =
    getCancelableRequestMeta(
      data,
      ActionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA,
      true
    );
  const payload = {
    serviceMethod: getEdgeTodayTransactionsDataApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA_FAILURE,
    actionTypeRequest: ActionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA_REQUEST,
    hideLoader,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA, payload };
};

export const clearGetEdgeTodayTransactionsDataAction = () => {
  return { type: ActionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA_CLEAR };
};

export const getOverviewDataAction = (data) => {
  const payload = {
    serviceMethod: getOverviewDataApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_OVERVIEW_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.GET_OVERVIEW_DATA_FAILURE,
    actionTypeRequest: ActionConstants.GET_OVERVIEW_DATA_REQUEST,
  };
  return { type: ActionConstants.GET_OVERVIEW_DATA, payload };
};

export const clearOverviewStateAction = () => {
  return { type: ActionConstants.GET_OVERVIEW_DATA_CLEAR };
};

export const getEdgeOverviewDataAction = (data) => {
  const { cancelKey, requestId, requestData, hideLoader, loaderMessage } =
    getCancelableRequestMeta(data, ActionConstants.GET_EDGE_OVERVIEW_DATA, true);
  const payload = {
    serviceMethod: getEdgeOverviewDataApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_EDGE_OVERVIEW_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.GET_EDGE_OVERVIEW_DATA_FAILURE,
    actionTypeRequest: ActionConstants.GET_EDGE_OVERVIEW_DATA_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_EDGE_OVERVIEW_DATA, payload };
};

export const clearEdgeOverviewStateAction = () => {
  return { type: ActionConstants.GET_EDGE_OVERVIEW_DATA_CLEAR };
};

export const getSettlementsOverViewDataAction = (data) => {
  const payload = {
    serviceMethod: getOverviewSettlementDataApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_SETTLEMENTS_OVERVIEW_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.GET_SETTLEMENTS_OVERVIEW_DATA_FAILURE,
    actionTypeRequest: ActionConstants.GET_SETTLEMENTS_OVERVIEW_DATA_REQUEST,
  };
  return { type: ActionConstants.GET_SETTLEMENTS_OVERVIEW_DATA, payload };
};

export const clearSettlementsOverviewStateAction = () => {
  return { type: ActionConstants.GET_SETTLEMENTS_OVERVIEW_DATA_CLEAR };
};

export const getEdgeSettlementsOverViewDataAction = (data) => {
  const { cancelKey, requestId, requestData, hideLoader, loaderMessage } =
    getCancelableRequestMeta(
      data,
      ActionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA,
      true
    );
  const payload = {
    serviceMethod: getEdgeOverviewSettlementDataApi.bind(null, requestData),
    actionTypeSuccess:
      ActionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_SUCCESS,
    actionTypeFailure:
      ActionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_FAILURE,
    actionTypeRequest:
      ActionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA, payload };
};

export const clearEdgeSettlementsOverviewStateAction = () => {
  return { type: ActionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_CLEAR };
};

export const getCheckoutInsightsPaymentPerformanceAction = (data) => {
  const { cancelKey, requestId, requestData, hideLoader, loaderMessage } =
    getCancelableRequestMeta(
      data,
      ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_ACTION,
      true
    );
  const payload = {
    serviceMethod: getCheckoutInsightsPaymentPerformanceAPI.bind(
      null,
      requestData
    ),
    actionTypeSuccess:
      ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_SUCCESS,
    actionTypeFailure:
      ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_FAILURE,
    actionTypeRequest:
      ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_ACTION, payload };
};

export const clearCheckoutInsightsPaymentPerformanceAction = () => {
  return { type: ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_CLEAR };
};

export const getCheckoutInsightsOfferEffectivenessAction = (data) => {
  const { cancelKey, requestId, requestData, hideLoader, loaderMessage } =
    getCancelableRequestMeta(
      data,
      ActionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_ACTION,
      true
    );
  const payload = {
    serviceMethod: getCheckoutInsightsOfferEffectivenessAPI.bind(
      null,
      requestData
    ),
    actionTypeSuccess:
      ActionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_SUCCESS,
    actionTypeFailure:
      ActionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_FAILURE,
    actionTypeRequest:
      ActionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_ACTION, payload };
};

export const clearCheckoutInsightsOfferEffectivenessAction = () => {
  return { type: ActionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_CLEAR };
};

export const getCheckoutInsightsPaymentModeBreakdownAction = (data) => {
  const { cancelKey, requestId, requestData, hideLoader, loaderMessage } =
    getCancelableRequestMeta(
      data,
      ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_ACTION,
      true
    );
  const payload = {
    serviceMethod: getCheckoutInsightsPaymentModeBreakdownAPI.bind(
      null,
      requestData
    ),
    actionTypeSuccess:
      ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_SUCCESS,
    actionTypeFailure:
      ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_FAILURE,
    actionTypeRequest:
      ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_ACTION, payload };
};

export const clearCheckoutInsightsPaymentModeBreakdownAction = () => {
  return { type: ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_CLEAR };
};

export const getCheckoutInsightsConversionFunnelAction = (data: {
  from: string;
  to: string;
  cancelKey?: string;
  requestId?: string;
  hideLoader?: boolean;
  loaderMessage?: string;
}) => {
  const { cancelKey, requestId, requestData, hideLoader, loaderMessage } =
    getCancelableRequestMeta(
      data,
      ActionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_ACTION,
      true
    );
  const payload = {
    serviceMethod: getCheckoutInsightsConversionFunnelAPI.bind(
      null,
      requestData
    ),
    actionTypeSuccess:
      ActionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_SUCCESS,
    actionTypeFailure:
      ActionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_FAILURE,
    actionTypeRequest:
      ActionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_ACTION, payload };
};

export const clearCheckoutInsightsConversionFunnelAction = () => {
  return { type: ActionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_CLEAR };
};
